module.exports = __webpack_public_path__ + "static/media/clients.ae4352ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/panel/clients.png
// module id = 73
// module chunks = 29